import {t} from 'i18next';
import moment from 'moment';
import {Card} from 'primereact/card';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import {TabPanel, TabView} from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../baseContainers/BaseDetailsContainer';
import ActionLink from '../components/ActionLink';
import DivContainer from '../components/DivContainer';
import YesNoDialog from '../components/YesNoDialog';
import InputCalendarComponent from '../components/inputs/InputCalendarComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import ProjectService from '../services/ProjectService';
import {withRouter} from 'react-router-dom';
import AuthService from '../services/AuthService';
import LogEntryListContainer from './LogEntryListContainer';
import ReportedUserDayService from '../services/userReport/ReportedUserDayService';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import Constants from '../utils/constants';
import InputTextareaComponent from '../components/inputs/InputTextareaComponent';
import SimpleReactValidator from '../components/validator';
import InputAutocompleteComponent from '../components/inputs/InputAutocompleteComponent';
import { UserActivityStatus } from '../model/enum/UserActivityStatus';
import UsersService from '../services/UsersService';
import { Exception } from 'sass';
import ActionButton from '../components/ActionButton';

class UserDayCreateContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new ReportedUserDayService());

        if (!this.authService.getProfile().allowMyTimeInPortal) {
            throw new Exception('No Access');
        }
        
        this.projectService = new ProjectService();
        this.authService = new AuthService();
        this.userService = new UsersService()

        const queryParams = new URLSearchParams(this.props.location.search);
        let activeIndexParam = parseInt(queryParams.get('activeIndex'));
        const projectId = queryParams.get('projectId')
        const userId = queryParams.get('userId');
        
        this.state = {
            
            activeIndex: activeIndexParam ? activeIndexParam : 0,
            projectId: projectId,
            userId : userId,
            loading: true,
            day: queryParams.get('day'),
            showFooterButtons: false,
            downloadingPdf: false,
            elementId: props.elementId,
            showConfirmRejectDialog: false,
            showConfirmReopenDialog: false,
            showApproveAlarmDialog: false,
            showConfirmAcceptDialog: false,
            rejectReason: null,
            projects: [],
            contractType: null,
            activities: {
                map: {}
            },            filteredUsers: [],
            editingFlag: true,
            activeFieldsModel: {
                map: {}
            },
            element:{
                day: queryParams.get('day'),
                user: undefined,
                events: []
            },
            newElement: {
                project: undefined,
                activity: undefined,
                event: {
                    status: {
                        label: 'Do akceptacji',
                        enumValue: 'TO_APPROVE'
                    },
                    userTime: undefined,
                    timeFrom: undefined,
                    timeTo: undefined,
                    comment: undefined,
                    selectedDay: queryParams.get('day'),
                }
            },
            next: 0
        };

        this.handleAddNewActivity = this.handleAddNewActivity.bind(this);
        this.handleEditActivity=this.handleEditActivity.bind(this);
        this.isRowActive = this.isRowActive.bind(this);
        this.normalizeListAfterRowEdit = this.normalizeListAfterRowEdit.bind(this);
        this.toggleEdit = this.toggleEdit.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.renderDetails=this.renderDetails.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.moveForward = this.moveForward.bind(this);
        this.goBackwards = this.goBackwards.bind(this);
        this.renderAddRow = this.renderAddRow.bind(this);
        this.userTimeTemplate = this.userTimeTemplate.bind(this);
        this.handleEditActivity=this.handleEditActivity.bind(this);
        this.isRowActive = this.isRowActive.bind(this);
        this.normalizeListAfterRowEdit = this.normalizeListAfterRowEdit.bind(this);

        this.rowValidator = new SimpleReactValidator({}, this.translate);
        this.addRowValidator = new SimpleReactValidator({}, this.translate);

        const getMinutes = (moment) => {
            const hours = moment.hours();
            const minutes = moment.minutes();
            return hours * 60 + minutes;
        }

        this.addRowValidator.addCustomRule('time_validation', t('userReporting.moreThanZeroValidaton'),
        (value, params) => {
            const element = this.state.newElement;
            if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                return element.event.userTime !== undefined && moment(element.event.userTime).format('HH:mm') !== '00:00'
            } else {
                return element.event.timeFrom !== undefined
                    && element.event.timeTo !== undefined
                    && moment(element.event.timeFrom).format('HH:mm') !== '00:00'
                    && moment(element.event.timeTo).format('HH:mm') !== '00:00'
            }
        }, (message, value) => message, true
    );

    this.addRowValidator.addCustomRule('from_to_validation', t('userReporting.fromToValidation'),
        (value, params) => {
            if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                return true;
            } else {
                return this.state.newElement.event.timeFrom !== undefined
                    && this.state.newElement.event.timeTo !== undefined
                    && getMinutes(moment(this.state.newElement.event.timeFrom)) < getMinutes(moment(this.state.newElement.event.timeTo))
            }
        }, (message, value) => message, true
    );

    this.addRowValidator.addCustomRule('creative_time_validation', 'Czas pracy twórczej nie może przekraczać czasu pracy',
        (value, params) => {
            const userTime = this.state.newElement.event.userTime;
            const creativeTime = this.state.newElement.event.creativeTime;

            if (userTime && creativeTime) {
                return getMinutes(moment(creativeTime))<= getMinutes(moment(userTime))
            }else{
                return true;
            }
        }, (message, value) => message, true
    );

    this.addRowValidator.addCustomRule('record_already_assigned', t('userReporting.record_already_assigned'),
        (value, params) => {
            const element = this.state.newElement;
            let result = true;
            if (element.activity && element.activity.id
                && element.project && element.project.id) {
                this.state.element.events.forEach((x) => {
                    const projectId = x?.project?.id;
                    const activityId = x?.activity?.id;
                    if (element.project.id === projectId && activityId === element.activity.id
                        && !this.authService.getProfile().timeReportingStartEndDateRequired) {

                        result = false;
                    }
                })
            }
            return result;
        }, (message, value) => message
    )

    this.addRowValidator.addCustomRule('record_already_assigned', t('userReporting.record_already_assigned'),
        (value, params) => {
            const element = this.state.newElement
            let result = true;

            this.state.element.events.forEach((x) => {
                if (element?.activity?.id === x.activity.id && !this.authService.getProfile().timeReportingStartEndDateRequired) {
                    result = false;
                }
            })
            return result;
        }, (message, value) => message, true
    )


    this.rowValidator.addCustomRule('creative_time_validation', 'Czas pracy twórczej nie może przekraczać czasu pracy',
        (value, params) => {
            const index = params[0];
            const userTime = this.state.element.events[index]?.event.userTime;
            const creativeTime = this.state.element.events[index]?.event.creativeTime;

            if (userTime && creativeTime) {
                return getMinutes(moment(creativeTime)) <= getMinutes(moment(userTime));
            }else{
                return true;
            }
        }, (message, value) => message, true
    );


    this.rowValidator.addCustomRule('record_already_assigned', t('userReporting.record_already_assigned'),
        (value, params) => {
            const element = this.state.element.events[params[0]];
            let result = true;

            if (element?.activity && element?.activity.id) {
                this.state.element.events.forEach((x) => {
                    const activityId = x?.activity?.id;
                    if (x.event.id !== element.event.id &&
                        activityId === element.activity.id && !this.authService.getProfile().timeReportingStartEndDateRequired) {
                        result = false;
                    }
                })
            }
            return result;
        }, (message, value) => message
    )
    this.rowValidator.addCustomRule('from_to_row_validation', t('userReporting.fromToValidation'),
        (value, params) => {
            if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                return true;
            } else {
                const index = params[0];
                const from = moment(this.state.element.events[index].event.timeFrom).toDate()
                const to = moment(this.state.element.events[index].event.timeTo).toDate()
                return from.getMinutes() + from.getHours() * 60 <
                    to.getMinutes() + to.getHours() * 60
            }
        }, (message, value) => message, true
    );


    this.rowValidator.addCustomRule('more_than_zero_row', t('userReporting.moreThanZeroValidaton'),
        (value, params) => {
            const index = params[0];

            if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                const userTime = this.state.element.events[index].event.userTime;
                return userTime !== undefined &&
                moment(userTime).isValid() &&
                moment(userTime).format('HH:mm') !== '00:00'
            } else {
                const from = this.state.element.events[index].event.timeFrom;
                const to = this.state.element.events[index].event.timeTo;
                return from !== undefined
                    && to !== undefined
                    && moment(from).isValid()
                    && moment(to).isValid()
                    && moment(from).format('HH:mm') !== '00:00'
                    && moment(to).format('HH:mm') !== '00:00'
            }
        }, (message, value) => message, true
    );
    }

    initBeforeSetElement() {
        this.setState({showFooterButtons: true});
    }

    initAfterSetElement() {
        super.initAfterSetElement();
    }
  
    isStartEndDateRequired() {
        return this.authService.getProfile().timeReportingStartEndDateRequired;
    }


    translateLevel(l) {
        if (l === 'CREATED') {
            return t('userReporting.create');
        }
        if (l === 'TO_APPROVE') {
            return t('userReporting.toApprove');
        }
        if (l === 'APPROVED') {
            return t('userReporting.approved');
        }
    }

    formatNumber(number) {
        if (!number) {
            return 0;
        }
        const formatter = new Intl.NumberFormat('pl-PL', {
            style: 'decimal',
            currency: 'PLN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        const formattedNumber = formatter.format(number);
        return formattedNumber;
    }

    getClosedInplaceComponentsMapForRow(rowIndex) {
        let data = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex) {
                data[[arr[0], arr[1]]] = false; //"zamknij" wszystkie inplace z danego wiersza
            }
        }
        return data;
    }

    cancelRowEdit(rowIndex) {
        const data = this.getClosedInplaceComponentsMapForRow(rowIndex);
        this.setState({
            activeFieldsModel: {
                map: data
            }
        })
    }

    getProjects() {
        this.projectService
            .reportableProjects(this.state.element.user?.id)
            .then(projects => this.setState({ projects: projects }))
            .catch(() => {
                this.showErrorMessage(t('userReporting.projectError'));
            });
    }

    getUserContractType() {
        this.userService
            .getUserContractType(this.state.element.user?.id, this.state.element?.day)
            .then(data => {
                this.setState({ contractType: data.contractType });
            })
            .catch((e) => {
                console.log(e)
                this.showErrorMessage(t('userReporting.contractTypeError'));
            });
    }

    isEmptyList() {
        return this.state.element.events.length === 0;
    }

    refreshAfterUpdate() {
        const url = `?day=${this.state.element.day}&projectId=${this.state.projectId}&userId=${this.state.userId}&activeIndex=${this.state.activeIndex}`
        this.props.history.push(url);
        this.refreshTable()
    }

    toggleEdit() {
        this.setState({
            viewMode: 'EDIT',
            editingFlag: true
        })
    }

    handleGoBack() {
        this.blockUi();
        const {backUrl} = this.props;
        window.location.href = backUrl;
    }

    handleSave() {
        if (this.rowValidator.allValid()) {
            this.scrollToTop();
            let { element } = this.state;
            this.service
                .addNewUserDay(element)
                .then(() => {
                    this.handleGoBack()
                })
                .catch((err) => {
                    this.unblockUi();
                    this.showErrorMessage(err.message)
                });
        } else {
            this.rowValidator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    handleCancel(){    
        this.blockUi();
        const {backUrl} = this.props;
        window.location.href = backUrl;
    }

    goBackwards() {
        this.setState({
            next: 0
        })
    }
    moveForward() {
        this.getProjects();
        this.setState({
            next: 1
        })
    }

    prepareFooterItems() {
        const result = []
        const roleApprove = this.authService.isUserInRole('ROLE_TIMESHEET_APPROVE');

        if (roleApprove) {
            if (this.state.next === 0) {
                if (this.state.element.user && this.state.element.day) {
                    result.push({
                        id:'next-button',
                        label: 'Dalej',
                        className: 'float-right',
                        onClick: this.moveForward
                    })
                }
                result.push({
                    label: 'Anuluj',
                    className: 'cancel-button white',
                    onClick: this.handleCancel
                });
            } else {
                if (this.state.element.events.length >= 1) {
                    result.push({
                        id:'save-button',
                        label: 'Zapisz',
                        className: 'float-right',
                        onClick: this.handleSave
                    })
                }

                result.push({
                    label: 'Wstecz',
                    className: 'cancel-button white',
                    onClick: this.goBackwards
                });
            }
        }
        return result;
    }



    isPdfButtonRendered() {
        return false;
    }

    getPdfDownloadLabel() {
        return null;
    }

  
    
    formatTime(time) {
        if (time) {
            const hours = Math.floor(time / 60);
            const mins = time % 60;
            return `${hours}:${mins.toString().padStart(2, '0')}`;
        } else {
            return '';
        }
    }




    canViewCardDetails() {
        return (this.props.viewMode === 'NEW' && this.state.next) && this.authService.isUserInAnyRoleArray(['ROLE_TIMESHEET_VIEW'])
    }


    createQueryString(queryObject = {}) {
        let queryString = Object.keys(queryObject)
            .filter((key) => queryObject[key] && !(Array.isArray(queryObject[key]) && !queryObject[key].length))
            .map((key) => {
                return Array.isArray(queryObject[key])
                    ? queryObject[key].map((item) => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`).join('&')
                    : `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`;
            })
            .join('&');
        return queryString ? `?${queryString}` : '';
    }


    renderCard() {
        return (
                <div style={{ minHeight: '900px' }}>
                    <Card className='details-card' footer={this.state.showFooterButtons && this.renderFooter()} header={this.renderHeader()}>
                            {this.renderDetails()}
                    </Card>
                </div>
        );
    }

    getClientColumn(rowData, prop) {
        const { rowIndex } = prop;

        return (
            <div>
                <td id={`project-display-${rowIndex}`} style={{
                    backgroundColor: 'inherit'
                }}>
                    <span
                        style={{
                            overflowWrap: 'break-word',
                            minWidth: '100%',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word'
                        }}>{`${rowData?.project?.client?.name}`}</span>
                </td>
            </div>
        );
    }


    getProjectColumn(rowData, prop) {
        const { rowIndex } = prop;
        return (
            <div>
                <InputDropdownComponent
                    id={`project-input-${rowIndex}`}
                    name='project'
                    colClass='col-md-7'
                    value={this.state.element.events[rowIndex].project}
                    className='custom-dropdown'
                    options={this.state.projects}
                    stateField={`element.events[${rowIndex}]`}
                    onChange={this.handleChange}
                    style={{
                        height: '33px',
                        maxWidth: '100%',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}
                    viewMode={'NEW'}
                    optionLabel='name'
                    dataKey='id'
                    validator={this.rowValidator}
                    validators={`required|record_already_assigned:${rowIndex}`}
                    validateViewMode={true}
                    placeholder={t('userReporting.project')}
                    filter
                    filterBy='name'
                    insideTable
                    onAfterStateChange={() => {
                        this.projectService
                            .getTimeReportingActivities(rowData.project.id)
                            .then(activities => {
                                let activeFields = this.state.activeFieldsModel.map;
                                if (!activities.map((x) => x?.id).includes(rowData.activity?.id)) {
                                    //usun aktywnosc jesli nie jest przypisana do wybranego projektu
                                    rowData.activity = null
                                    const activityColumnIndex = 2;
                                    activeFields[[rowIndex, activityColumnIndex]] = true; //usuwana jest aktywnosc ktorej nie ma w projekcie, 
                                    //user musi ustawic aktywnosc z projektu, pole zostaje "otwarte" do edycji
                                }
                                const data = this.state.activities.map;
                                data[rowIndex] = activities;
                                this.setState((prev) => (({
                                    activeFieldsModel: {
                                        map: activeFields
                                    },
                                    activities: {
                                        map: data
                                    }
                                })))
                            }).catch(() => {
                                this.setState({
                                    activities: {
                                        map: {}
                                    }
                                })
                                this.showErrorMessage(t('userReporting.activityError'));
                            })
                    }}
                />
            </div>
        );
    }

    getActionsColumn(rowData, prop) {
        const { rowIndex } = prop;
        const isRowActive = this.isRowActive(rowIndex);
        
        return (
            <div style={{ display: 'flex', justifyContent: 'start', maxWidth: '60px', marginLeft: '10px' }}>
                {isRowActive ? (
                    <>
                        <ActionLink
                            iconName='pi pi-check'
                            iconPrefix='pi'
                            iconSide='left'
                            iconSize='icon-medium'
                            rendered={true}
                            color='black'
                            handleClick={(e) => {
                                this.handleEditActivity(rowData, rowIndex)
                            }}
                            classN
                            ame='edit-blue-link'
                            key={'delete-button'}
                        />
                        <ActionLink
                            iconName='mdi mdi-cancel'
                            iconSize='icon-medium'
                            rendered={true}
                            handleClick={(e) => {
                                this.cancelRowEdit(rowIndex)
                                this.refreshTable()
                            }}
                            color='black'
                            classN
                            ame='edit-blue-link'
                            key={'delete-button'}
                        />

                    </>
                ) : (
                    <ActionLink
                        iconName='mdi mdi-delete'
                        iconSize='icon-medium'
                        rendered={true}
                        handleClick={(e) => {
                            this.handleDeleteActivity(rowData, rowIndex)
                        }}
                        color='black'
                        classN
                        ame='edit-blue-link'
                        key={'delete-button'}
                    />)}
            </div>
        )
    }


    onToggleFunction(rowIndex, columnIndex, activeFieldsModel) {
        let data = activeFieldsModel.map;
        if (data[[rowIndex, columnIndex]] === undefined || data[[rowIndex, columnIndex]] === false) {
            data[[rowIndex, columnIndex]] = true;
            this.setState({
                activeFieldsModel: {
                    map: data
                }
            })
        }
    }

    getIsActive(rowIndex, columnIndex, activeFieldsModel) {
        return (activeFieldsModel?.map[[rowIndex, columnIndex]]) ? true : false;
    }


    getActivityColumn(rowData, prop) {
        const { rowIndex } = prop;
        // this.loadActivitiesForRow(rowData, rowIndex)
        return (
            <div>
                <InputDropdownComponent
                    id='activity-input'
                    name='activity'
                    colClass='col-lg-2 col-sm-2 col-md-2'
                    value={rowData?.activity}
                    validator={this.rowValidator}
                    validators={`required|record_already_assigned:${rowIndex}`}
                    label={t('userReporting.activity')}
                    stateField={`element.events[${rowIndex}]`}
                    showLabel={false}
                    options={this.state.activities.map[rowIndex]} //aktywnosci przypisane do projektu
                    onChange={this.handleChange}
                    style={{
                        height: '33px',
                        maxWidth: '100%',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}
                    className='custom-dropdown'
                    viewMode={'NEW'}
                    optionLabel='name'
                    dataKey='id'
                    labe={t('userReporting.activity')}
                    placeholder={t('userReporting.activity')}
                    filter
                    filterBy='name'
                    insideTable
                />
            </div>
        );
    }

    getCommentColumn(rowData, prop) {
        const { rowIndex } = prop;
        const { column } = prop;

        return <div className='admin-view-text-area' style={{
            marginTop: '4px'
        }}>
            <InputTextareaComponent
                id="comment-sc"
                className='admin-view-text-area'
                name="comment"
                colClass="col-xl-14 col-lg-14 col-md-14 col-sm-14"
                value={rowData.event.comment}
                stateField={`element.events[${prop.rowIndex}].event`}
                onChange={this.handleChange}
                maxlength={500}
                viewMode={'NEW'}
                global
                viewStyle={{ minHeight: '19px', minWidth: '180px', width: 'fit-content', maxWidth: '100%', wordBreak: 'break-word' }}
                refreshFromBackend
                timeoutHandler={this.refreshTable}
                autoResize
            />
        </div>
    }

    getMinutes(date){
        const hours = moment(date).hours();
        const minutes = moment(date).minutes();
        return moment(new Date()).format('YYYY-MM-DD') + ' ' + hours + ':' + minutes;
    }



    normalizeListAfterRowEdit(list) {
        //moze byc case ze user zedytuje kilka pol w kilku wierszach
        // i bedzie kazdy wiersz po kolei zapisywac 
        // przy zapisie edycji jest refresh listy wiec juz po jednym zapisie wszystkim polom przypisana zostanie wartosc z bazy 
        // i user bedzie musial od nowa edytowac.
        let rowsToIgnore = []
        const data = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (value) { //jesli dla danej kolumny jest ustawione true
                rowsToIgnore.push(
                    arr[0] //dodaj, ktory wiersz nalezy "zignorowac"
                );
            }
        }
        const currentList = this.state.element.events; //obecne wartosci z listy
        return list.map((valueFromDb, index) =>
            rowsToIgnore.includes(index) ? currentList[index] : valueFromDb
            //jesli indeks matchuje sie z wierszem do "zignorowania", ustaw wartosc ze state else wez zaktualizowana wartosc
        ); //wtedy po zapisie user zachowa zmiany w innych edytowanych wierszach
    }


    getUserTimeColumn(rowData, prop) {
        const { rowIndex } = prop;
        const { column } = prop;

        rowData.event.userTime = rowData.event.userTime ? moment(rowData.event.userTime).toDate() : null;
        rowData.event.timeFrom = rowData.event.timeFrom ? moment(rowData.event.timeFrom).toDate() : null;
        rowData.event.timeTo = rowData.event.timeTo ? moment(rowData.event.timeTo).toDate() : null;

        const startEndRequired = this.isStartEndDateRequired();
        const width = startEndRequired ? '140px' : '70px';

        let formattedUserTime = '';
        if (startEndRequired) {
            formattedUserTime = rowData.event.timeFrom && rowData.event.timeTo ? `${moment(rowData.event.timeFrom).format('H:mm')}-${moment(rowData.event.timeTo).format('H:mm')}` : ``;
        } else {
            formattedUserTime = moment(rowData.event.userTime).format('HH:mm');
        }
        return (
            <div>
                <div style={{ display: 'flex', justifyContent: 'start', padding: 0, width: '65px', maxWidth: '65px' }}>
                    {!startEndRequired ? (
                        <InputCalendarComponent
                            id={`usertime-content-${rowIndex}`}
                            name={'userTime'}
                            value={rowData.event.userTime}
                            stateField={`element.events[${rowIndex}].event`}
                            onChange={this.handleChange}
                            viewMode={'NEW'}
                            showLabel={false}
                            insideTable
                            showTime
                            validator={this.rowValidator}
                            label={t('userReporting.workTime')}
                            dateFormatMoment='HH:mm'
                            className='user-reporting-time-style'
                            timeOnly
                            validateViewMode={true}
                            validators={`more_than_zero_week_row:${rowIndex}|required`}
                            placeholder=''
                            showSeconds={false}
                            showIcon={false}
                            icon={() => <i className='clock' />}
                            readOnlyInput={false}
                            propCustomValue={true}
                            mask='99:99'
                            style={{
                                width: '50px',
                                maxWidth: '60px',
                                boxSizing: 'border-box'
                            }}
                            showOnFocus={false}
                            customTimePicker={(e) => {
                            }}
                            onInputClick={this.onInputClick}
                            trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                        />
                    ) : (
                        <div style={{ minWidth: width, '--bs-gutter-x': '0.2rem' }} className='row'>
                            <div className='col'>
                                <InputCalendarComponent
                                    id={`time-from-input-inside-list-${rowIndex}`}
                                    name={`timeFrom`}
                                    value={rowData.event.timeFrom}
                                    stateField={`element.events[${rowIndex}].event`}
                                    onChange={this.handleChange}
                                    viewMode={'NEW'}
                                    showLabel={false}
                                    insideTable
                                    showTime
                                    validator={this.rowValidator}
                                    validators={`more_than_zero_week_row:${rowIndex}|from_to_row_validation:${rowIndex}`}
                                    validateViewMode={true}
                                    label={t('userReporting.workTime')}
                                    dateFormatMoment='HH:mm'
                                    className='user-reporting-time-style'
                                    timeOnly
                                    placeholder=''
                                    showSeconds={false}
                                    showIcon={false}
                                    icon={() => <i className='clock' />}
                                    readOnlyInput={false}
                                    propCustomValue={true}
                                    mask='99:99'
                                    style={{
                                        maxWidth: '50px',
                                        width: '60px',
                                        boxSizing: 'border-box'
                                    }}
                                    showOnFocus={false}
                                    customTimePicker={(e) => {
                                    }}
                                    onInputClick={this.onInputClick}
                                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                                />
                            </div>
                            <div className='col'>
                                <InputCalendarComponent
                                    id={`time-to-input-inside-list-${rowIndex}`}
                                    name={`timeTo`}
                                    value={rowData.event.timeTo}
                                    stateField={`element.events[${rowIndex}].event`}
                                    onChange={this.handleChange}
                                    viewMode={'NEW'}
                                    showLabel={false}
                                    insideTable
                                    className='user-reporting-time-style'
                                    showTime
                                    validator={this.rowValidator}
                                    validators={`more_than_zero_week_row:${rowIndex}|from_to_row_validation:${rowIndex}`}
                                    validateViewMode={true}
                                    dateFormatMoment='HH:mm'
                                    timeOnly
                                    placeholder=''
                                    mask='99:99'
                                    showSeconds={false}
                                    showIcon={false}
                                    icon={() => <i className='clock' />}
                                    readOnlyInput={false}
                                    propCustomValue={true}
                                    style={{
                                        maxWidth: '50px',
                                        width: '60px',
                                    }}
                                    customTimePicker={(e) => {
                                    }}
                                    onInputClick={this.onInputClick}
                                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    isCreativeTimeColumnRequired() {
        const isStartEndNotRequired = !this.isStartEndDateRequired(); //tylko dla opcji z wpisywaniem ilości godzin
        const userHasPernamentContract = this.state.contractType === 'PERNAMENT';//i tylko kiedy sprawdzany uzytkownik ma umowe o prace
        return this.authService.getProfile().featureCreativeWorkReportingEnabled && isStartEndNotRequired && userHasPernamentContract 
    }

    creativeTimeTemplate(rowData, props) {
        return (
            <div className='col-sm'>
                <InputCalendarComponent
                    id={'creativeTime-add-row'}
                    name={'creativeTime'}
                    value={this.state.newElement?.event?.creativeTime}
                    stateField={'newElement.event'}
                    onChange={this.handleChange}
                    viewMode={this.props.viewMode}
                    label={t('userReporting.creativeTime')}
                    showLabel={false}
                    insideTable
                    showTime
                    className='user-reporting-time-style'
                    dateFormatMoment='HH:mm'
                    timeOnly
                    validateViewMode={false}
                    placeholder='HH:mm'
                    showSeconds={false}
                    showIcon={false}
                    validator={this.addRowValidator}
                    validators={'creative_time_validation'}
                    icon={() => <i className='clock' />}
                    readOnlyInput={false}
                    mask='99:99'
                    propCustomValue={true}
                    style={{
                        height: '34px',
                        width: '50px',
                        maxWidth: '50px'
                    }}
                    showOnFocus={false}
                    customTimePicker={(e)=>{
                    }}
                    onInputClick={this.onInputClick}
                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                />
            </div>
        );
    }
    getCreativeTimeColumn(rowData, prop) {
        const { rowIndex } = prop;
        const { column } = prop;

        rowData.event.creativeTime = rowData.event.creativeTime ? moment(rowData.event.creativeTime).toDate() : null;
        // let formattedUserTime = '';
        const isCreativeTimeNotReported = !rowData.event.creativeTime || rowData.event?.creativeTime === 0;
        // formattedUserTime = isCreativeTimeNotReported ? '00:00' : moment(rowData.event.creativeTime).format('HH:mm');

        return (
            <div id='creative-time-inplace' >
                <div style={{ display: 'flex', justifyContent: 'start', padding: 0, width: '65px', maxWidth: '65px' }}>
                    {(
                        <InputCalendarComponent
                            id={`creativeTime-content-${rowIndex}`}
                            name={'creativeTime'}
                            value={rowData.event.creativeTime}
                            stateField={`element.events[${rowIndex}].event`}
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            showLabel={false}
                            insideTable
                            showTime
                            validator={this.rowValidator}
                            validators={`creative_time_validation:${rowIndex}`}
                            label={t('userReporting.creativeTime')}
                            dateFormatMoment='HH:mm'
                            className='user-reporting-time-style'
                            timeOnly
                            validateViewMode={true}
                            placeholder='HH:mm'
                            showSeconds={false}
                            showIcon={false}
                            icon={() => <i className='clock' />}
                            readOnlyInput={false}
                            propCustomValue={true}
                            mask='99:99'
                            style={{
                                height: '34px',
                                maxWidth: '50px',
                                width: '60px',
                                boxSizing: 'border-box'
                            }}
                            showOnFocus={false}
                            customTimePicker={(e) => {
                            }}
                            onInputClick={this.onInputClick}
                            trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                        />
                    )}
                </div>
            </div>
        );
    }


    onInputClick(id) {
        const input = document.getElementById(id)
        input.focus();
        input.setSelectionRange(0, 0);
    }

    prepareColumns() {
        const startEndRequired = this.isStartEndDateRequired();
        const creativeTimeColumnRequired = this.isCreativeTimeColumnRequired()

        let columns = [
            {
                field: 'client.name',
                header: t('userReporting.client'),
                body: this.getClientColumn.bind(this),
                width: '110px'
            },
            {
                field: 'project.name',
                header: t('userReporting.project'),
                body: this.getProjectColumn.bind(this),
                width: '130px'
            },
            {
                field: 'activity.name',
                header: t('userReporting.activity'),
                body: this.getActivityColumn.bind(this),
                width: '150px'
            },
            {
                field: 'comment',
                header: t('userReporting.comment'),
                body: this.getCommentColumn.bind(this),
                width:'100%'
            },
            {
                field: 'userTime',
                header: startEndRequired ? t('userReporting.hours') : t('userReporting.workTime'),
                body: this.getUserTimeColumn.bind(this),
                width: startEndRequired && !creativeTimeColumnRequired  ? '140px' : '65px'
            },
        ];

        if(creativeTimeColumnRequired){
            columns.push({
                field: 'creativeTime',
                header: 'Praca twórcza',
                body: this.getCreativeTimeColumn.bind(this),
                width: '65px'
            });
        }

        columns.push({
            field:'',
            header: '',
            body: this.getActionsColumn.bind(this),
            width: '155px'
        });

        return columns;
    }
    

    refreshTable() {
    }

    closeOpenInplaceComponents(data, rowIndex) {
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex) {
                data[[arr[0], arr[1]]] = false; //"zamknij" wszystkie inplace z danego wiersza
            }
        }
    }

    handleDeleteActivity(rowData, rowIndex) {
        let data = this.state.activeFieldsModel.map;
        this.closeOpenInplaceComponents(data, rowIndex);

        let events = this.state.element.events.filter(x => x.event !== rowData.event)
        this.setState((prev) => ({
            loading: false,
            activeFieldsModel: {
                map: data
            },
            element:{
                ...prev.element,
                events: events
            }
        }))
    }

    loadActivitiesForRow(rowData, rowIndex) {
        this.projectService
            .getTimeReportingActivities(rowData.project.id)
            .then(activities => {
                if (!activities.map((x) => x?.id).includes(rowData.activity?.id)) {
                    //usun aktywnosc jesli nie jest przypisana do wybranego projektu
                    rowData.activity = null
                }
                const data = this.state.activities.map;
                data[rowIndex] = activities;
                this.setState(({
                    activities: {
                        map: data
                    }
                }))
            }).catch(() => {
                this.setState({
                    activities: {
                        map: {}
                    }
                })
                this.showErrorMessage(t('userReporting.activityError'));
            })
    }
    

    handleEditActivity(rowData, rowIndex) {
        if (this.rowValidator.allValid()) {

            let data = this.state.activeFieldsModel.map;
            this.closeOpenInplaceComponents(data, rowIndex);
            this.setState({
                loading: false,
                activeFieldsModel: {
                    map: data
                }
            });
        } else {
            this.rowValidator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }


    handleAddNewActivity() {
        //  TODO
        const { newElement } = this.state;

        if (this.addRowValidator.allValid()) {
            let events = this.state.element.events;
            //dodawany element
            const element = this.cloneElement(newElement);
            events.push(element);

            //dociagnij aktywnosci do nowo dodanego wiersza
            const currentRow = events.length-1; 
            this.loadActivitiesForRow(element, currentRow)


            this.setState(
                {
                    loading: true,
                }, () => {
                    this.setState((prev) => ({
                        loading: false,
                        element: {
                            ...prev.element,
                            events: events
                        },
                        newElement: {
                            project: undefined,
                            activity: undefined,
                            event: {
                                status: {
                                    label: 'Do akceptacji',
                                    enumValue: 'TO_APPROVE'
                                },
                                userTime: undefined,
                                timeFrom: undefined,
                                timeTo: undefined,
                                comment: undefined,
                            }
                        },
                    }), () => {
                        this.addRowValidator.hideMessages()
                    });
                }
            );

        } else {
            this.addRowValidator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    isRowActive(rowIndex) {
        const data = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex && data[[arr[0], arr[1]]]) { //jesli dla danej kolumny jest ustawione true
                return true;
            }
        }
        return false;
    }


    isStartEndDateRequired() {
        return this.authService.getProfile().timeReportingStartEndDateRequired
    }

    footerGroup() {
        return this.renderAddRow();
    }


    generateCustomFooterIfPossible() {
        return this.footerGroup();
    }

    fromToUserTimeTemplate(rowData, props) {
        // FROM - TO, 8 am - 2 pm.
        const rowIndex = props?.rowIndex;
        return (
            <div style={{ '--bs-gutter-x': '0.2rem', width: '140px' }} className='row'>
                <div className='col-sm'>
                    <InputCalendarComponent
                        id={`user-time-from-${rowIndex}`}
                        name={`timeFrom`}
                        value={this.state.newElement.event.timeFrom}
                        stateField={'newElement.event'}
                        onChange={this.handleChange}
                        viewMode={'NEW'}
                        showLabel={false}
                        insideTable
                        showTime
                        validator={this.addRowValidator}
                        dateFormatMoment='HH:mm'
                        className='user-reporting-time-style'
                        timeOnly
                        validateViewMode={false}
                        placeholder=''
                        showSeconds={false}
                        showIcon={false}
                        icon={() => <i className='clock' />}
                        readOnlyInput={false}
                        label={t('userReporting.timeFrom')}
                        propCustomValue={true}
                        mask='99:99'
                        style={{
                            width: '50px',
                            maxWidth: '50px',
                            boxSizing: 'border-box',
                            position: 'static'
                        }}
                        customTimePicker={(e)=>{
                        }}
                        onInputClick={this.onInputClick}
                        trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                    />
                </div>
                <div className='col-sm'>
                    <InputCalendarComponent
                        id={`user-time-to-${rowIndex}`}
                        name={`timeTo`}
                        value={this.state.newElement.event.timeTo}
                        stateField={'newElement.event'}
                        onChange={this.handleChange}
                        viewMode={'NEW'}
                        showLabel={false}
                        insideTable
                        showTime
                        validator={this.addRowValidator}
                        dateFormatMoment='HH:mm'
                        timeOnly
                        validateViewMode={false}
                        placeholder=''
                        className='user-reporting-time-style'
                        showSeconds={false}
                        showIcon={false}
                        icon={() => <i className='clock' />}
                        readOnlyInput={false}
                        label={t('userReporting.timeTo')}
                        propCustomValue={true}
                        mask='99:99'
                        style={{
                            width: '50px',
                            maxWidth: '50px',
                            boxSizing: 'border-box',
                            position: 'static'
                        }}
                        customTimePicker={(e)=>{                                           
                        }}
                        onInputClick={this.onInputClick}
                        trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                    />
                </div>
            </div>
        );
    }

    userTimeTemplate(rowData, props) {
        return (
            <div className='col-sm'>
                <InputCalendarComponent
                    id={'usertime-add-row'}
                    name={'userTime'}
                    value={this.state.newElement.event.userTime}
                    stateField={'newElement.event'}
                    onChange={this.handleChange}
                    viewMode={'NEW'}
                    label={t('userReporting.workTime')}
                    showLabel={false}
                    insideTable
                    showTime
                    className='user-reporting-time-style'
                    dateFormatMoment='HH:mm'
                    timeOnly
                    validateViewMode={false}
                    placeholder='HH:mm'
                    showSeconds={false}
                    showIcon={false}
                    validator={this.addRowValidator}
                    validators={'time_validation'}
                    icon={() => <i className='clock' />}
                    readOnlyInput={false}
                    mask='99:99'
                    propCustomValue={true}
                    style={{
                        width: '50px',
                        maxWidth: '50px'
                    }}
                    showOnFocus={false}
                    customTimePicker={(e)=>{        
                    }}
                    onInputClick={this.onInputClick}
                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                />
            </div>
        );
    }

    formattedTimeToMinutes(time) {
        const split = time.split(':');
        return (Number(split[0] * 60)) + Number(split[1])
    }

    getSummary(list) {
        const startEndRequired = this.isStartEndDateRequired()
        let mappedList = []
        if (startEndRequired) {
            mappedList = list.map((x) => {
                return this.formattedTimeToMinutes(moment(x.event.timeTo).format('HH:mm')) - this.formattedTimeToMinutes(moment(x.event.timeFrom).format('HH:mm'))
            })
        } else {
            mappedList = list.map((x) => this.formattedTimeToMinutes(moment(x.event.userTime).format('HH:mm')))
        }
        let totalMinutes = 0;
        for (let i = 0; i < mappedList.length; i++) {
            totalMinutes += mappedList[i];
        }

        let creativeTimeSummary = 0;
        let creativeTimeList = list.filter(x => x.event.creativeTime).map((x) => this.formattedTimeToMinutes(moment(x.event.creativeTime).format('HH:mm')))
        for (let i = 0; i < creativeTimeList.length; i++) {
            creativeTimeSummary += creativeTimeList[i];
        }

        return {
            totalMinutes: totalMinutes,
            creativeTimeSummary: creativeTimeSummary
        }
    }

    renderAddRow() {
        const startEndRequired = this.isStartEndDateRequired();
        const creativeTimeColumnRequired = this.isCreativeTimeColumnRequired();

        const summary = this.getSummary(this.state?.element?.events);
        let formattedSummary = this.formatTime(summary?.totalMinutes);
        let formattedCreativeTimeSummary = this.formatTime(summary?.creativeTimeSummary);

        return <ColumnGroup>
            {this.state?.element?.events?.length >= 1 ?
                <Row id='summaryRow'>
                        <Column footer="Podsumowanie" colSpan={2} footerStyle={{ textAlign: "left" }} />
                        <Column footer="" colSpan={2} footerStyle={{ textAlign: "right" }} />
                        <Column
                            style={{ whiteSpace: "nowrap" }}
                            footer={
                                summary?.totalMinutes
                                    ? `${formattedSummary} / 8h`
                                    : "00:00 / 8h"
                            }
                            footerStyle={{ textAlign: "left" }}
                        />
                        {creativeTimeColumnRequired ?
                            <Column
                                style={{ whiteSpace: "nowrap" }}
                                footer={
                                    summary.creativeTimeSummary
                                        ? `${formattedCreativeTimeSummary} / 8h`
                                        : "00:00 / 8h"
                                }
                                footerStyle={{ textAlign: "left" }}
                            />
                            : null}
                        <Column />
                </Row> : null}


                {this.state?.element?.events?.length === 0 ?
                <Row>
                    <Column id='emptyMessage' footer="Brak danych do wyświetlenia - Dodaj nowy wpis" colSpan={creativeTimeColumnRequired ? 7 : 6} footerStyle={{ textAlign: "center", backgroundColor: 'white' }} />
                </Row>
                : null
            }
            <Row>
                <Column footer="Nowy wpis" colSpan={creativeTimeColumnRequired ? 7 : 6} footerStyle={{ textAlign: "left", color: 'gray', backgroundColor: 'white', border: 'white' }} />
            </Row>
            <Row>
                <Column style={{
                    position: 'static',
                    border: 'white'
                }} footer={() => {
                    //KLIENT
                    return (
                        <InputDropdownComponent
                            id='client-row'
                            name='client'
                            value={this.state.newElement?.project?.client}
                            validator={this.addRowValidator}
                            options={this.state.projects}
                            onChange={this.handleChange}
                            viewMode={'VIEW'}
                            optionLabel='name'
                            dataKey='id'
                            validators='required|record_already_assigned'
                            label={t('userReporting.project')}
                            showLabel={false}
                            placeholder={t('userReporting.project')}
                            filter
                            filterBy='name'
                            className='custom-dropdown'
                            insideTable
                            style={{
                                height: '33px',
                                boxSizing: 'border-box'
                            }}
                        />
                    )
                }} />
                <Column style={{
                    width: '400px',
                    maxWidth: '400px',
                    position: 'static',
                    border: 'white'
                }} footer={() => {
                    //PROJEKT
                    return (
                        <InputDropdownComponent
                            id='project-row'
                            name='project'
                            stateField={'newElement'}
                            value={this.state.newElement.project}
                            validator={this.addRowValidator}
                            options={this.state.projects}
                            onChange={this.handleChange}
                            viewMode={'NEW'}
                            optionLabel='name'
                            dataKey='id'
                            validators='required|record_already_assigned'
                            label={t('userReporting.project')}
                            showLabel={false}
                            placeholder={t('userReporting.project')}
                            filter
                            filterBy='name'
                            className='custom-dropdown'
                            insideTable
                            style={{
                                height: '33px',
                                maxWidth: '100%',
                                width: '100%',
                                boxSizing: 'border-box'
                            }}
                            onAfterStateChange={(e) => {
                                this.projectService
                                    .getTimeReportingActivities(this.state.newElement?.project.id)
                                    .then(activities => {
                                        if (!activities.map((x) => x?.id).includes(this.state.newElement.activity?.id)) {
                                            //usun aktywnosc jesli nie jest przypisana do wybranego projektu
                                            this.state.newElement.activity = null;
                                        }
                                        this.setState(({
                                            addRowActivities: activities

                                        }))
                                    }).catch(() => {
                                        this.setState({
                                            addRowActivities: []
                                        })
                                        this.showErrorMessage(t('userReporting.activityError'));
                                    })
                            }}
                        />
                    )
                }}
                />
                <Column
                    style={{
                        position: 'static',
                        border: 'white'
                    }}
                    footer={() => {
                        //AKTYWNOŚĆ
                        return (
                            <InputDropdownComponent
                                id='activity'
                                name='activity'
                                value={this.state.newElement?.activity}
                                colClass='col-xl-12 col-lg-12 col-md-12 col-sm-12'
                                options={this.state.addRowActivities}

                                // aktywnosci przypisane do projektu

                                label={t('userReporting.activity')}
                                showLabel={false}
                                onChange={(a, b, c, d) => {
                                    let newElement = this.state.newElement;
                                    newElement.activity = c.target.value
                                    this.setState({
                                        newElement: newElement
                                    })
                                }}
                                viewMode={'NEW'}
                                optionLabel='name'
                                dataKey='id'
                                className='custom-dropdown'
                                validator={this.state.newElement.project === undefined ? null : this.addRowValidator}
                                validators='required|record_already_assigned'
                                placeholder={t('userReporting.activity')}
                                filter
                                filterBy='name'
                                insideTable
                                disabled={this.state.newElement.project === undefined}
                                style={{
                                    height: '33px',
                                    maxWidth: '100%',
                                    width: '100%',
                                    boxSizing: 'border-box'
                                }}
                            />
                        )
                    }}
                />
                <Column
                    style={{
                        position: 'static',
                        border: 'white'
                    }}
                    footer={() => {
                        //KOMENTARZ
                        return (<div className='admin-view-text-area' style={{
                            marginTop: '5px'
                        }}>
                            <InputTextareaComponent
                                id="comment-sc"
                                name="comment"
                                colClass="col-xl-12 col-lg-12 col-md-12 col-sm-12"
                                value={this.state.newElement.event.comment}
                                stateField={'newElement.event'}
                                viewMode={'NEW'}
                                onChange={this.handleChange}
                                maxlength={500}
                                global
                                refreshFromBackend
                                timeoutHandler={this.refreshTable}
                                autoResize
                            />
                        </div>
                        )
                    }}
                />
                <Column
                    style={{
                        border: 'white'
                    }}
                    footer={() => {
                        return (
                            <div>
                                {startEndRequired ? this.fromToUserTimeTemplate() : this.userTimeTemplate()}
                                <div
                                    style={{
                                        position: 'absolute',
                                        marginTop: '3px'
                                    }}
                                >
                                    <span>{this.addRowValidator.message('', '', '', 'time_validation|from_to_validation|creative_time_validation')}</span>
                                </div>
                            </div>
                        );
                    }}
                />
                {creativeTimeColumnRequired ?
                    <Column
                        style={{
                            border: 'white'
                        }}
                        footer={() => {
                            return (
                                <div>
                                    {this.creativeTimeTemplate()}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            marginTop: '3px'
                                        }}
                                    >
                                    </div>
                                </div>
                            );
                        }}
                    /> : null
                }
                <Column
                    style={{
                        border: 'white'
                    }}
                    footer={() => (
                        <div id='addRowButton'>
                            <ActionButton
                                label="Dodaj wpis"
                                handleClick={this.handleAddNewActivity.bind(this)}
                                style={{ width: "fit-content" }}
                            />
                        </div>
                    )}
                />
            </Row>
        </ColumnGroup>
    }

    searchUsers(query) {
        this.userService
            .search(query, null, UserActivityStatus.ACTIVE, null, null, null, null, 'ROLE_REPORT_OWN_TIME') //wszyscy aktywni z uprawnieniem ROLE_REPORT_OWN_TIME
            .then(filteredUsers => {
                this.setState({ filteredUsers })
            }).catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy pracowników')
            })
    }

    renderDetails() {
        const isEmpty = this.isEmptyList();
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <DivContainer colClass='col-md-12'>
                        <Card>
                            <DivContainer colClass='row'>
                                <InputCalendarComponent
                                    id='day'
                                    name='day'
                                    label={t('project.date')}
                                    value={this.state.element.day}
                                    stateField={'element'}
                                    colClass='col-md-4'
                                    onChange={this.handleChange}
                                    viewMode={'NEW'}
                                    validator={this.validator}
                                    validators='required'
                                    showIcon
                                    showClear
                                    showTime={false}
                                    propCustomValue={true}
                                />

                                <InputTextComponent
                                    id='level'
                                    name='level'
                                    label={t('global.status')}
                                    colClass='col-md-4'
                                    value={this.state.element.status}
                                    validators='required|max:150'
                                    validator={this.validator}
                                    onChange={this.handleChange}
                                    viewMode={'VIEW'}
                                    renderValue={(e) => {
                                        return e?.label;
                                    }}
                                    rendered={this.props.viewMode !== 'NEW'}
                                />
                            </DivContainer>
                            <DivContainer colClass='row'>
                                <div className='col-md-4'>
                                    <InputAutocompleteComponent
                                        id={`users`}
                                        name="user"
                                        colClass=''
                                        label={t('global.user')}
                                        validators='required|max:150'
                                        value={this.state.element.user}
                                        dropdown
                                        forceSelection
                                        validator={this.validator}
                                        showLabel={true}
                                        onChange={this.handleChange}
                                        insideTable={true}
                                        filteredList={this.state.filteredUsers}
                                        filterList={query => this.searchUsers(query)}
                                        field="fullName"
                                        disabled={!this.state.element.day}
                                        viewMode={'NEW'}
                                        minLength={3}
                                        placeholder={t('search.users.placeholder')}
                                        onAfterStateChange={() => {
                                            this.getProjects();
                                            this.getUserContractType();
                                        }}
                                        />
                                </div>
                                <InputTextComponent
                                    id='level'
                                    name='level'
                                    label={t('reportedDay.level')}
                                    colClass='col-md-4'
                                    value={this.state.element?.levelName}
                                    validators='required|max:150'
                                    validator={this.validator}
                                    onChange={this.handleChange}
                                    viewMode={'VIEW'}
                                    rendered={this.props.viewMode !== 'NEW'}
                                />
                            </DivContainer>
                        </Card>
                    </DivContainer>

                    {this.canViewCardDetails() ? (
                        <DivContainer colClass='col-md-12'>
                            <TabView
                                activeIndex={this.state.activeIndex}
                                onTabChange={(e) => {
                                    const url = `${this.props.elementId}?day=${this.state.day}&projectId=${this.state.projectId}&userId=${this.state.userId}&activeIndex=${e.index}`
                                    this.setState({activeIndex: e.index}, () => {
                                        this.props.history.push(url);
                                    });
                                }}
                            >
                                <TabPanel header={'Aktywności'}>
                                    <Card header='Aktywności'>
                                        <DivContainer colClass='row'>
                                            <DataTable
                                                id='dataTable'
                                                key='data-table'
                                                value={this.state.element.events}
                                                sortField='id'
                                                className={isEmpty ? 'empty-table' : 'fixed-datatable'}
                                                emptyMessage={t('list.empty')}
                                                footerColumnGroup={this.generateCustomFooterIfPossible()}
                                                responsiveLayout='scroll'
                                                tableStyle={{
                                                    'table-layout': 'fixed',
                                                    minWidth:'850px'
                                                }}
                                                rowClassName={(rowData, obj) => {
                                                    const acceptLevel = rowData.event.acceptLevel
                                                    const isUserApproved = acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL //&& acceptLevel !== Constants.PM_APPROVED_LEVEL
                                                    const isPmApproved = acceptLevel === Constants.PM_APPROVED_LEVEL
                                                    return isUserApproved ? {
                                                        'user-approved-row': true
                                                    } : (isPmApproved ? {
                                                        'pm-approved-row': true
                                                    } : null)
                                                }}
                                            >
                                                {this.prepareColumns().map((col, index) => {
                                                    return (
                                                        <Column
                                                            selectionMode={col.selectionMode}
                                                            key={col.key ? col.key : col.field}
                                                            field={col.field}
                                                            filter
                                                            filterField={col.field}
                                                            showFilterMenu={false}
                                                            header={col.header}
                                                            body={col.body}
                                                            bodyClassName={col.bodyClassName}
                                                            headerClassName={col.headerClassName}
                                                            className={col.className}
                                                            sortable={col.sortable}
                                                            sortField={col.sortField !== undefined ? col.sortField : col.field}
                                                            style={col.width !== undefined ? { width: col.width, maxWidth: col.width } : null}
                                                            columnIndex={index}
                                                        />
                                                    );
                                                })}
                                            </DataTable>
                                        </DivContainer>
                                    </Card>
                                </TabPanel>
                                {this.props.viewMode !== 'NEW' ? (
                                    <TabPanel header={t('logEntry.list.title')}>
                                        <LogEntryListContainer
                                            objectType='USER_DAY'
                                            objectId={this.props.elementId}
                                            expandFilters={false}
                                            renderHeader={false}
                                        />
                                    </TabPanel>
                                ) : null}                                
                            </TabView>
                        </DivContainer>
                    ) : null}
                </DivContainer>                
                {this.state.showConfirmRejectDialog ? (
                    <YesNoDialog
                        visible={this.state.showConfirmRejectDialog}
                        header={t('userReporting.rejectHeader')}
                        name='visible'
                        childrenDivClassname='row'
                        onChange={(type, x, target) => {
                            if (target.value) {
                                if (this.validator.allValid()) {
                                    this.handleReject();
                                    this.setElement();
                                } else {
                                    this.validator.showMessages();
                                    this.scrollToError = true;
                                    this.forceUpdate();
                                }
                            } else {
                                this.hideRejectConfirmation();
                            }
                        }}
                        style={{
                            width: 'fit-content'
                        }}
                        onHide={() => {
                            this.hideRejectConfirmation();
                        }}
                    >
                        <InputTextareaComponent
                            validator={this.validator}
                            id={'reject-reason-text-area'}
                            label={t('userReporting.reject_reason')}
                            value={this.state.rejectReason}
                            name='rejectReason'
                            showLabel={true}
                            insideTable
                            rendered={true}
                            onChange={(a,b,c,d)=>{
                                this.setState({
                                    rejectReason: c.target.value
                                })
                            }}
                            style={{
                                width: '100%',
                            }}
                            maxlength={100}
                            viewMode={'NEW'}
                            autoResize
                        />

                    </YesNoDialog>
                ) : this.state.showConfirmAcceptDialog ? (
                    <YesNoDialog
                        visible={this.state.showConfirmAcceptDialog}
                        header={t('userReporting.confirmHeader')}
                        name='visible'
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.handleAcceptUserDay();
                                this.setState({ showConfirmAcceptDialog: false })
                            } else {
                                this.setState({ showConfirmAcceptDialog: false })
                            }
                        }}
                        onHide={() => {
                            this.setState({ showConfirmAcceptDialog: false })
                        }}
                    >
                        {t('userReporting.confirmMessage')}
                    </YesNoDialog>
                ) : this.state.unlockDialogVisible ? (
                    <YesNoDialog
                        visible={this.state.unlockDialogVisible}
                        header={t('userReporting.unlockHeader')}
                        name='visible'
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.handleUnlockUserDay();
                                this.setState({ unlockDialogVisible: false })
                            } else {
                                this.setState({ unlockDialogVisible: false })
                            }
                        }}
                        onHide={() => this.setState({ unlockDialogVisible: false })}
                    >
                        {t('userReporting.unblockMessage')}
                    </YesNoDialog>
                ) : null}
            </React.Fragment>
        );
    }
}

UserDayCreateContainer.defaultProps = {
    backUrl: '/#/reported-day-list',
};

UserDayCreateContainer.propTypes = {
    backUrl: PropTypes.string,
};

export default withRouter(withTranslation()(UserDayCreateContainer));
